import React from 'react'
import { Link } from 'react-router-dom'

import { Helmet } from 'react-helmet'

import Flowambassador1 from '../components/flowambassador1'
import './join.css'

const Join = (props) => {
  return (
    <div className="join-container1">
      <Helmet>
        <title>Join - @Romania NGO</title>
        <meta
          name="description"
          content="Democratizing tourism by changing the way we plan, book and travel."
        />
        <meta property="og:title" content="Join - @Romania NGO" />
        <meta
          property="og:description"
          content="Democratizing tourism by changing the way we plan, book and travel."
        />
        <meta
          property="og:image"
          content="https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/262a7285-ee36-4827-90cf-bff2da51d3e3/e678668e-577d-45ce-9b60-b935d207ee1c?org_if_sml=1&amp;force_format=original"
        />
        <link
          rel="canonical"
          href="https://copy-of-romania-ngo-democratizing-tourism-via-web3-9ihr-naighba.vercel.app/join"
        />
        <meta
          property="og:url"
          content="https://copy-of-romania-ngo-democratizing-tourism-via-web3-9ihr-naighba.vercel.app/join"
        />
      </Helmet>
      <div className="join-thq-hero-elm">
        <div className="join-thq-nav-elm">
          <div data-role="Header" className="join-thq-header-container-elm">
            <header className="join-thq-navbar-elm">
              <Link to="/" className="join-navlink1">
                <div className="join-thq-branding-elm">
                  <img
                    alt="pastedImage"
                    src="/logo/romania_logo.svg"
                    className="join-thq-romania-elm"
                  />
                </div>
              </Link>
              <Link to="/ambassadors" className="join-navlink2">
                <div className="join-thq-btn-elm">
                  <span className="join-text1 formula_button">Read more</span>
                  <span className="join-text2">Read more</span>
                </div>
              </Link>
            </header>
          </div>
        </div>
        <div className="join-thq-text-elm container_1600">
          <Flowambassador1 rootClassName="flowambassador1root-class-name"></Flowambassador1>
        </div>
        <img alt="image" src="/map.svg" className="join-thq-map-elm" />
        <img
          alt="image"
          src="/compressed-5000w.gif"
          className="join-thq-gif-elm"
        />
      </div>
    </div>
  )
}

export default Join
